import React from 'react';
import { Tooltip, Tag } from 'antd';

function RenderToolTipWaiting({title}) {
  return (
    <Tooltip title={title}>
      <Tag color="#FB607F">Waiting Payment</Tag>
    </Tooltip>
  );
}

export default RenderToolTipWaiting;
